class EksClusterLinksFormatter {
  async formatClusterLink(_options) {
    throw new Error(
      "EKS formatter is not yet implemented. Please, contribute!"
    );
  }
}

export { EksClusterLinksFormatter };
//# sourceMappingURL=EksClusterLinksFormatter.esm.js.map
